import React, { useState } from "react";
import {
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import { RefreshCcw } from "react-feather";

const FilterProductFields = ({
  rarityList,
  categoryList,
  handleSearchProduct,
  handleGetRustItems,
  handleGameSelect,
  handleComparePrice,
  isInventory,
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  const toggleModal = () => setModalOpen(!modalOpen);

  const confirmRefresh = () => {
    handleGetRustItems();
    toggleModal();
  };

  return (
    <>
      <FormGroup className="search_boxes_section search-box-section justify-content-center">
        <div className="row">
          <div className="addbox-input col-xl-4 col-md-4">
            <Label className="col-form-label pt-0">
              <span></span> Search Here
            </Label>
            <input
              type="text"
              placeholder="Search"
              name="title"
              onChange={(e) => handleSearchProduct(e)}
              className="form-control"
            />
            <i className="fa fa-search search-icon"></i>
          </div>

          <div className="addbox-input col-xl-4 col-md-4">
            <Label className="col-form-label pt-0">
              <span></span> Min
            </Label>
            <i className="fa fa-dollar dollar-icon"></i>
            <input
              name="min"
              onChange={(e) => handleSearchProduct(e)}
              className="form-control"
              type="number"
              placeholder="Min"
            />
          </div>

          <div className="addbox-input col-xl-4 col-md-4">
            <Label className="col-form-label pt-0">
              <span></span> Max
            </Label>
            <i className="fa fa-dollar dollar-icon"></i>
            <input
              name="max"
              onChange={(e) => handleSearchProduct(e)}
              className="form-control"
              type="number"
              placeholder="Max"
            />
          </div>

          {!isInventory && (
            <div className="addbox-input col-xl-12 col-md-12">
              <div className="search-section">
                <div className="search-category">
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={() => handleComparePrice()}
                  >
                    Compare Price
                  </button>

                  <select
                    className="category-search"
                    name="category"
                    onChange={(e) => handleGameSelect(e)}
                  >
                    {/* <option value='730'>CSGo</option> */}
                    <option value="252490">RUST</option>
                    {/* <option value='570'>DOTA-2</option> */}
                  </select>

                  <select
                    className="category-search"
                    name="category"
                    onChange={(e) => handleSearchProduct(e)}
                  >
                    <option value="">Choose Category</option>
                    {categoryList?.map((el) => (
                      <option key={el.value} value={el.value}>
                        {el.label}
                      </option>
                    ))}
                  </select>

                  <select
                    className="category-search"
                    name="rarity"
                    onChange={(e) => handleSearchProduct(e)}
                  >
                    <option value="">Choose Rarity</option>
                    {rarityList?.map((el) => (
                      <option key={el.value} value={el.value}>
                        {el.label}
                      </option>
                    ))}
                  </select>

                  <div className="pl-2">
                    <button onClick={toggleModal} className="btn btn-primary">
                      <RefreshCcw />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </FormGroup>

      {/* Refresh Confirmation Modal */}
      <Modal isOpen={modalOpen} toggle={toggleModal} centered>
        <ModalBody className="text-light bg-dark">
          Confirm Refresh        </ModalBody>
        <ModalBody className="text-center text-dark">
          Are you sure you want to reset marketplace?         </ModalBody>
        <ModalFooter className="justify-content-end gap-2">
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
          <Button color="primary" onClick={confirmRefresh}>
            Yes, Refresh
          </Button>
        </ModalFooter>


      </Modal>
    </>
  );
};

export default FilterProductFields;
